import React from 'react';

import Layout from '../../Layout/index';
import NewsList from '../../NewsList/index';


const Tech = () => {
    return (
        <Layout title="Tech News - Bull & Bear"> 
            <NewsList category="technology" />
        </Layout>
    )
};

export default Tech;